export const props = Object.freeze({
  /**
   * JSON definition URL for this admin index.
   * @type {String}
   */
  filtersUrl: { type: String, default: "" },
  /**
   * Applied count shown before the definition loads.
   * @type {Number|String}
   * @storybook-control number
   */
  appliedCount: { type: [Number, String], default: 0 },
  /**
   * Index identifier passed to an optional filter chooser.
   * @type {String}
   */
  index: { type: String, default: "" },
  /**
   * Save URL passed to an optional filter chooser.
   * @type {String}
   */
  saveUrl: { type: String, default: "" },
});
